import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';

export default function EditKitabName({
    editKitabNameInfo,
    setEdit,
}) {
    const [kitabNameInfo, setKitabNameInfo] = useState({});
    const [kitabHiddenUpdateInfo, setKitabHiddenUpdateInfo] = useState({});

      //get all kitab 
      useEffect(()  => {     
        async function fetchData() {   
         const kitab = await axios.get(`https://ahlehaqserver.herokuapp.com/api/kitab`)
         setKitabHiddenUpdateInfo(kitab.data.response.find(data => data.kitabName === editKitabNameInfo.kitabName));
        }
        fetchData(); 
        setKitabNameInfo(editKitabNameInfo);
      },[])
     
     
    const KitabNameUpdate = async (e) => {
        e.preventDefault();

        try {
          //update kitab name info
           const insertKitabName = await axios.put(`https://ahlehaqserver.herokuapp.com/api/kitabName/${editKitabNameInfo._id}`, kitabNameInfo);
        
           if(insertKitabName.data.code === 200){
              setEdit(false);
              toast.success("Kitab name edited successfully!");
           }

        
           //update kitab information
            const khu = {
              kitabName:  kitabNameInfo.kitabName,
            }

           const kitabInserted = await axios.put(
            `https://ahlehaqserver.herokuapp.com/api/kitab/${kitabHiddenUpdateInfo._id}`,
            khu
          );
  
          //if request success, will show success notification
          if (kitabInserted.data.code === 200) {
            setKitabHiddenUpdateInfo({});
            
          }
        }catch{

        }
   }

    return (
        <div>
        <form onSubmit={KitabNameUpdate}>
            <div className="row">
            
                 <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                        Write kitab name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control rounded"
                          placeholder="Write kitab name"
                          id="exampleInputPassword1"
                          name="kitabName"
                          value={kitabNameInfo?.kitabName || ""}
                          required
                          onChange={(e) =>
                            setKitabNameInfo((prev) => ({
                              ...prev,
                              [e.target.name]: e.target.value,
                            }))
                          }
                        />
                      </div>
                   </div>

                   <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                        Writer name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control rounded"
                          placeholder="Write kitab name"
                          id="exampleInputPassword1"
                          name="writerName"
                          value={kitabNameInfo?.writerName || ""}
                          required
                          onChange={(e) =>
                            setKitabNameInfo((prev) => ({
                              ...prev,
                              [e.target.name]: e.target.value,
                            }))
                          }
                        />
                      </div>
                   </div>

                   <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                        Image Link<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control rounded"
                          placeholder="Write image url"
                          id="exampleInputPassword1"
                          name="imageUrl"
                          value={kitabNameInfo?.imageUrl || ""}
                          required
                          onChange={(e) =>
                            setKitabNameInfo((prev) => ({
                              ...prev,
                              [e.target.name]: e.target.value,
                            }))
                          }
                        />
                      </div>
                   </div>

                       <div className="col-md-6">
                       <div className="form-group">
                           <label for="exampleInputEmail1" className="font-weight-bold">
                             Select Language<span className="text-danger">*</span>
                           </label>
                           
                           <select
                             className="form-control rounded"
                             id="exampleInputEmail1"
                             name="bangla"
                             value={kitabNameInfo?.bangla || ""}
                             required
                             onChange={(e) =>
                                setKitabNameInfo((prev) => ({
                                 ...prev,
                                 [e.target.name]: e.target.value,
                               }))
                             }
                           >
                             <option>
                               Select Boyan Language
                             </option>
                                 <option value="true">
                                   Bangla
                                 </option>
                                 <option value="false">
                                   Urdu
                                 </option>
                           </select>  
                       </div>
                     </div>

                     <div className="col-md-6">
                       <div className="form-group">
                           <label for="exampleInputEmail1" className="font-weight-bold">
                             Is it a pdf book?<span className="text-danger">*</span>
                           </label>
                           
                           <select
                             className="form-control rounded"
                             id="exampleInputEmail1"
                             name="pdf"
                             value={kitabNameInfo?.pdf || ""}
                             required
                             onChange={(e) =>
                                setKitabNameInfo((prev) => ({
                                 ...prev,
                                 [e.target.name]: e.target.value,
                               }))
                             }
                           >
                             <option>
                               Select from th list
                             </option>
                                 <option value="true">
                                   Yes
                                 </option>
                                 <option value="false">
                                   NO
                                 </option>
                           </select>  
                       </div>
                     </div>


                   <div className="col-md-12">
                        <div className=" d-flex">
                                <button
                                    type="submit"
                                    className="btn btn-success rounded px-4 ml-auto"
                                >
                                    Done
                                </button>

                                <button
                                    className="btn btn-danger ml-2"
                                    onClick={() => setEdit(false)}
                                >
                                    Close
                                </button>
                            </div>
                   </div>
                  
            </div>
        </form>
    </div>
    )
}
